import { Link } from "react-router-dom";
import "../../../styles/pages/dashboard/adminDashboardPageComponent.scss";

export const AdminDashboardPageComponent = () => {
  const dashboardItems = [
    {
      title: "קטגוריות",
      link: "?d=category&action=manage",
      description: "ניהול קטגוריות המוצרים",
      icon: "fa-solid fa-folder-tree",
    },
    {
      title: "משתמשים",
      link: "?d=account&action=manage",
      description: "ניהול משתמשי המערכת",
      icon: "fa-solid fa-users",
    },
    {
      title: "סוכנים",
      link: "?d=agent&action=manage",
      description: "ניהול סוכני מכירות ושיוך לקוחות",
      icon: "fa-solid fa-user-tie",
    },
    {
      title: "הזמנה ללקוח",
      link: "?d=customer&action=select",
      description: "בחירת לקוח וביצוע הזמנה בשמו",
      icon: "fa-solid fa-cart-plus",
    },
    {
      title: "הגדרות אתר",
      link: "?d=websiteComfiguration&action=manage",
      description: "ניהול הגדרות האתר",
      icon: "fa-solid fa-gear",
    },
    {
      title: "פריטים",
      link: "items",
      description: "ניהול פריטים ומוצרים",
      icon: "fa-solid fa-box",
    },
    {
      title: "הזמנות",
      link: "orders",
      description: "צפייה וניהול הזמנות",
      icon: "fa-solid fa-shopping-bag",
    },
    {
      title: "ניהול קטלוג",
      link: "catalog",
      description: "יצירה והורדה של קטלוג PDF",
      icon: "fa-solid fa-file-pdf",
    },
  ];

  return (
    <div className="adminDashboardContainer">
      <div className="adminDashboardHeader">
        <h1 className="adminDashboardTitle">איזור ניהול</h1>
        <p className="adminDashboardSubtitle">בחר את האזור שברצונך לנהל</p>
      </div>

      <div className="adminDashboardGrid">
        {dashboardItems.map((item, index) => (
          <Link key={index} to={item.link} className="adminDashboardCard">
            <div className="adminDashboardCardIcon">
              <i className={item.icon}></i>
            </div>
            <div className="adminDashboardCardContent">
              <h3 className="adminDashboardCardTitle">{item.title}</h3>
              <p className="adminDashboardCardDescription">{item.description}</p>
            </div>
          </Link>
        ))}
      </div>

      {/* <BusinessOrdersTableComponent /> */}
    </div>
  );
};

export default AdminDashboardPageComponent;
